import React from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';

import { Typography } from '@/components/atoms/Typography';
import { Button } from '@/components/molecules/Button';
import { RestaurantStatus } from '@/components/molecules/RestaurantStatus';
import { SeeRestaurantClaiming } from '@/components/organisms/SeeRestaurantClaiming';
import { useApproveClaimMutation, useFetchClaimQuery, useRejectClaimMutation, useRejectClaimWithTokenMutation } from '@/api/hooks/useClaim';
import { useFetchRestaurantQuery } from '@/api/hooks/useRestaurant';
import { ClaimStatus } from '@/api/lib/claim';

export const ModerationClaimPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const claimId = id || '';
  const { data: claim, isLoading: isClaimLoading } = useFetchClaimQuery({ id: claimId });

  const restaurantId = claim?.restaurantId || '';
  const { data: restaurant, isLoading: isRestaurantLoading } = useFetchRestaurantQuery({ id: restaurantId }, { enabled: !!restaurantId });

  const { isLoading: isApprovingRestaurant, mutate: approveRestaurant } = useApproveClaimMutation({
    onSuccess: () => {
      toast.success('Transfert de propriété approuvé', {
        position: 'bottom-right'
      });
      navigate('/?tab=claim');
    }
  });

  const { isLoading: isRejectingRestaurant, mutate: rejectRestaurant } = useRejectClaimMutation({
    onSuccess: () => {
      toast.success('Transfert de propriété rejeté', {
        position: 'bottom-right'
      });
      navigate('/?tab=claim');
    }
  });

  const handleApprove = () => {
    approveRestaurant(claimId);
  };

  const handleRejectClick = () => {
    rejectRestaurant(claimId);
  };

  const buttonsLoading = isApprovingRestaurant || isRejectingRestaurant;

  return (
    <>
      <section className="bg-primary">
        <section className="mb-5 -mt-14 pt-32 md:pt-44 p-8 md:p-14 flex bg-primary w-full flex-col relative">
          <Typography variant="heroTitle" align="center" color="white">
            Est-ce que le transfert de propriété est-il conforme ?
          </Typography>
        </section>

        <section className="bg-white md:rounded-t-[60px] rounded-t-[30px] pt-5 md:pt-14 pb-40 w-full">
          <div className="md:max-w-[90%] md:p-0 p-4 mx-auto">
            <SeeRestaurantClaiming isLoading={isRestaurantLoading || isClaimLoading} restaurantData={restaurant} claimData={claim} />
          </div>
        </section>
      </section>

      <div className="w-full fixed bottom-0">
        <div className="flex flex-col gap-4 xl:w-2/6 md:w-3/6 p-4 md:px-10 bg-primary justify-center rounded-t-[30px] border-x border-primary/10 font-bold mx-auto">
          {claim?.status === ClaimStatus.PENDING && (
            <>
              <div className="flex gap-4">
                <Button loading={buttonsLoading} onClick={handleApprove} fullWidth color="success" label="Accepter le transfert" />
                <Button loading={buttonsLoading} onClick={handleRejectClick} fullWidth color="white" label="Refuser le transfert" />
              </div>
            </>
          )}

          {claim?.status === ClaimStatus.REJECTED && (
            <div className="flex items-center justify-center flex-col">
              <Typography variant="h4" align="center" weight="bold" color="white">
                Ce transfert de propriété a déjà été rejeté.
              </Typography>
            </div>
          )}

          {claim?.status === ClaimStatus.APPROVED && (
            <div className="flex items-center justify-center flex-col">
              <div className="flex items-center gap-3 ">
                <RestaurantStatus status={restaurant?.validationStatus} circleOnly />
                <Typography variant="h4" align="center" weight="bold" color="white">
                  Propriétaire déjà transféré
                </Typography>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
